import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { laytonUTConfig } from "./data";

export default function LaytonUTPage() {
  return <CityPageTemplate config={laytonUTConfig} />;
}